import { Stack, Theme, Divider } from '@mui/material';
import { ReactNode } from 'react';

import { SizingMultiplier } from '../sizing-multiplier.constant';

type ListProps = {
  children?: ReactNode;
  disabledPaddings?: boolean;
  hideDivider?: boolean;
  spacing?: number;
};

const disabledPaddingMx = (theme: Theme) => `${theme.spacing(-SizingMultiplier.md)}!important`;

export const List = (props: ListProps) => {
  const { children, disabledPaddings, hideDivider, spacing = 0 } = props;
  return (
    <Stack
      divider={hideDivider ? undefined : <Divider variant="middle" />}
      mx={disabledPaddings ? disabledPaddingMx : undefined}
      spacing={spacing}
      color="text.primary">
      {children}
    </Stack>
  );
};
